// frontend-react/src/pages/HomePage.tsx
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getUserRoleDisplay } from '../services/authService';
import { hasPermission as checkPermission } from '../utils/permissions';
import PageLayout from '../components/PageLayout';
import './HomePage.css';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const hasPermission = useCallback(
    (permission: string) => checkPermission(user, permission),
    [user]
  );

  return (
    <PageLayout currentPage='/'>
      {/* 主內容 */}
      <main className='main'>
        <section className='feature-grid'>
          {/* 卡片 1：全文審閱 */}
          <article
            className={`feature-card ${!hasPermission('can_view_rules') ? 'disabled' : ''}`}
            aria-labelledby='title-review'
          >
            <div className='feature-accent' />

            <header className='feature-header'>
              <div>
                <span className='feature-eyebrow'>功能</span>
                <span id='title-review' className='feature-title'>
                  全文審閱
                </span>
                {hasPermission('can_view_rules') ? (
                  <span className='permission-badge success'>✅ 可使用</span>
                ) : (
                  <span className='permission-badge locked'>🔒 無權限</span>
                )}
              </div>
            </header>

            <div className='feature-media'>
              <div
                className='media rules'
                style={{ backgroundImage: `url(/images/contract_rules.png)` }}
                role='img'
                aria-label='全文審閱範例圖片'
              />
            </div>

            <div className='feature-body'>
              <p className='feature-desc'>上傳廣告文宣，套用「審閱規則」並輸出風險報告與建議。</p>
              <ul className='feature-steps'>
                <li>
                  <span className='bullet' />
                  <span>上傳廣告文宣或合約</span>
                </li>
                <li>
                  <span className='bullet' />
                  <span>系統自動套用預設規則審查</span>
                </li>
                <li>
                  <span className='bullet' />
                  <span>AI 輸出風險報告與建議</span>
                </li>
                {hasPermission('can_access_all_features') && (
                  <li>
                    <span className='bullet' />
                    <span>🔧 管理審查規則和政策 (僅管理員)</span>
                  </li>
                )}
                {!hasPermission('can_access_all_features') && user && (
                  <li>
                    <span className='bullet' />
                    <span>📋 查看審查規則 (當前角色: {getUserRoleDisplay(user)})</span>
                  </li>
                )}
              </ul>
              <div className='file-support'>📎 支援格式：.pdf、.docx</div>
            </div>

            <footer className='feature-footer'>
              <button
                className={`cta ${!hasPermission('can_view_rules') ? 'disabled' : ''}`}
                type='button'
                onClick={hasPermission('can_view_rules') ? () => navigate('/ad-review') : undefined}
                disabled={!hasPermission('can_view_rules')}
              >
                {hasPermission('can_view_rules') ? '開始審閱' : '無法使用'}
              </button>
            </footer>
          </article>
        </section>
      </main>
    </PageLayout>
  );
};

export default HomePage;
